import {
  MessageCategory,
  MessageType,
  convertFolderItemToMessage,
} from 'utils/Message';
import fetchAPI from 'utils/fetchAPI';

/**
 * SET PERSONAL FOLDER TABLE DIMENSIONS
 */
export const SET_TABLE_DIMENSIONS = 'SET_TABLE_DIMENSIONS';

const setDimensions = ({ width, height }) => ({
  type: SET_TABLE_DIMENSIONS,
  width,
  height,
});

export const setFolderTableDimensions = ({ width, height }) => (
  dispatch,
  getState
) =>
  new Promise((resolve, reject) =>
    dispatch(
      setDimensions({
        width,
        height,
      })
    )
  );

/**
 * SEARCH PERSONAL FOLDER
 * TODO require backend support
 */
export const SAVE_KEYWORD = 'SAVE_KEYWORD';

const saveKeyword = keyword => ({
  type: SAVE_KEYWORD,
  keyword,
});

export const setKeyword = ({ keyword }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch(saveKeyword(keyword));
    return resolve();
  });

/**
 * CLEAR PERSONAL FOLDER DATA
 */

export const CLEAR_DATA = 'CLEAR_DATA';

export const clearData = () => ({
  type: CLEAR_DATA,
});

/**
 * FETCH PERSONAL FOLDER
 */
export const INIT_LOADING = 'INIT_LOADING';
export const FINISH_LOADING = 'FINISH_LOADING';

export const initLoading = ({ offset, size }) => ({
  type: INIT_LOADING,
  offset,
  size,
});

export const finishLoading = ({ offset, result, count }) => ({
  type: FINISH_LOADING,
  offset,
  result,
  count,
});

export const getPersonalFolder = ({ offset, size }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch(initLoading({ offset, size }));

    const token = getState().users.token;
    fetchAPI({
      endpoint:
        `/messages/all?size=${size}&from=${offset}` +
        `&message_types=${MessageType.FORM}&message_types=${MessageType.PDF}` +
        `&message_types=${MessageType.IMAGE}` +
        `&table_name=${MessageCategory.P2P_MESSAGE}` +
        `&table_name=${MessageCategory.GROUP_CHAT_MESSAGE}` +
        `&table_name=${MessageCategory.DRAFT}` +
        `&table_name=${MessageCategory.CHANNEL_MESSAGE}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(response => response.json())
      .then(json => {
        const count = json.summary.total;
        if (count === 0) {
          dispatch(clearData());
          return;
        }
        const prevCount = getState().folder.totalPersonalFormCount;
        if (count !== prevCount) {
          dispatch(clearData());
        }
        const result = json.messages.map(e => {
          try {
            return convertFolderItemToMessage(e);
          } catch (err) {
            return {};
          }
        });
        return dispatch(finishLoading({ offset, result, count }));
      });
  });



// WEBPACK FOOTER //
// ./app/actions/FolderActionCreators.js